<nav #headerNavBar class="header-box navbar navbar-expand-lg">
  <div class="d-flex align-items-center gap-4 me-auto">
    <div class="header-title">
      {{ 'headerMenu.myPortal' | translate }}
    </div>
    <div *ngIf="subTenants?.length > 1" class="header-subtenants-select">
      <kendo-combobox HJSuppress
          class="custom-kendo-control-l"
          [fillMode]="fillModeOutline"
          [rounded]="roundedLarge"
          [size]="sizeLarge"
          name="subTenant"
          placeholder="{{'headerMenu.selectTenant' | translate}}"
          [clearButton]="false"
          [data]="subTenants"
          [textField]="'name'"
          [valueField]="'id'"
          [valuePrimitive]="false"
          [(ngModel)]="selectedSubTenant"
          (ngModelChange)="subTenantSelectHandler($event)"
          #selectSubTenant
          (click)="!selectSubTenant.isOpen ? selectSubTenant.toggle() : null"
          [popupSettings]="{popupClass : 'data-hj-suppress'}"
      >
      </kendo-combobox>
    </div>
  </div>

  <div class="header-content d-flex align-items-center">
    <div role="button" class="user-notifications d-flex" 
      autoClose="outside" 
      [ngbPopover]="notificationsPopover" 
      popoverClass="popover-no-arrow notifications-popover"
      placement="bottom-right"
      #notificationsPopOver="ngbPopover"
      [positionTarget]="headerNavBar"
    >
      <span *ngIf="numberOfNotifications > 0"
        class="notification-badge fw-bold position-absolute d-flex align-items-center justify-content-center rounded-circle"
      >
        {{(numberOfNotifications > maxVisibleNumberOfNotifications) ? (maxVisibleNumberOfNotifications + '+') : numberOfNotifications }}
      </span>
      <i class="header-notification-icon app-icon icon icon-bell icon-xxl"></i>
    </div>

    <div *ngIf="isAdmin === false" role="button" 
      class="user-notifications d-flex" 
      (click)="onUserNavOptionSelect(USER_NAV_ACTIONS.FAQ, false)"
    >
      <i class="header-notification-icon app-icon icon icon-question-circle icon-xxl"></i>
    </div>
  
    <button type="button" class="navbar-toggler"
      (click)="openMobileNav(mobileNavigation)"
    >
      <span class="navbar-toggler-icon"></span>
    </button>
  </div>
</nav>

<ng-template #notificationsPopover>
  <notification *ngIf="hasUserRights" 
    (closeNotificationsPopOver)="closeNotificationsPopOver()"
  ></notification>
</ng-template>

<ng-template #settingsActions>
  <div class="actions-box d-flex flex-column gap-2 px-3">
    <div class="divider mt-2"></div>
    <button class="btn menu-option-btn" (click)="onUserNavOptionSelect(USER_NAV_ACTIONS.MY_PROFILE)">
      <i class="app-icon icon icon-user icon-lg"></i>
      <span>{{'headerMenu.myProfile' | translate}}</span>
    </button>
    <button *ngIf="showAppVersion" class="btn menu-option-btn" 
      (click)="onUserNavOptionSelect(USER_NAV_ACTIONS.ABOUT)">
      <i class="app-icon icon icon-warning-circle icon-lg"></i>
      <span>{{'headerMenu.about' | translate}}</span>
    </button>
    <button *ngIf="isAdmin" class="btn menu-option-btn" (click)="onUserNavOptionSelect(USER_NAV_ACTIONS.MY_CSS)">
      <i class="app-icon icon icon-settings icon-lg"></i>
      <span>{{'headerMenu.settingsActions.cssFile' | translate}}</span>
    </button>
    <button class="btn menu-option-btn" (click)="onUserNavOptionSelect(USER_NAV_ACTIONS.LANGUAGE_SWITCHER)">
      <i class="app-icon icon icon-world icon-lg"></i>
      <span>{{'common.selectLanguage' | translate}}</span>
    </button>
    <button class="btn menu-option-btn" (click)="onUserNavOptionSelect(USER_NAV_ACTIONS.LOGOUT)">
      <i class="app-icon icon icon-log-out icon-lg"></i>
      <span>{{'headerMenu.logout' | translate}}</span>
    </button>
  </div>
</ng-template>

<ng-template #mobileNavigation let-offcanvas>
  <div class="offcanvas-header">
    <div class="d-flex align-items-center gap-3">
      <app-user-badge 
        badgeTheme="2"
        [username]="username" 
        [width]="40" 
        [height]="40" 
        fontSize="16px">
      </app-user-badge>
      <span class="username-label fw-semibold">{{username}}</span>
    </div>

    <button type="button" class="btn-close" aria-label="Close" (click)="offcanvas.close()"></button>
  </div>

  <div class="offcanvas-body py-0">
    <div class="main-nav-menu-items d-flex flex-column gap-2 px-3">
      <ng-container *ngFor="let item of menuItems">
        @if (item.features && item.features.length > 0) {
          <div ngbAccordion class="sub-menu-items-accordion" [closeOthers]="true">
            <div ngbAccordionItem="accordionItem" #accordionItem="ngbAccordionItem">
              <div ngbAccordionHeader>
                <button ngbAccordionButton type="button" class="btn menu-option-btn">
                  <i class="app-icon icon icon-{{item.icon}} icon-lg"></i>
                  <span class="item-text">{{ item.name }}</span>
                </button>
              </div>
              <div ngbAccordionCollapse>
                <div ngbAccordionBody>
                  <ng-template>
                    <ng-container *ngFor="let subItem of item.features">
                      <button type="button" class="btn menu-option-btn"
                        [routerLink]="'./' + subItem.path"
                        (click)="offcanvas.close(subItem)"
                      >
                        <span class="item-text">{{ subItem.name }}</span>
                      </button>
                    </ng-container>
                  </ng-template>
                </div>
              </div>
            </div>

          </div>
        } @else {
          <button type="button" class="btn menu-option-btn"
            [ngClass]="{ 'btn-primary selected' : item.selected }"
            [routerLink]="'./' + item.path"
            (click)="offcanvas.close(item)"
          >
            <i class="app-icon icon icon-{{item.icon}} icon-lg"></i>
            <span class="item-text">{{ item.name }}</span>
          </button>
        }
      </ng-container>
    </div>
  </div>

  <div class="offcanvas-footer pt-0">
    <ng-template [ngTemplateOutlet]="settingsActions"></ng-template>
  </div>
</ng-template>